import { render, staticRenderFns } from "./OverallSessionDurationChart.vue?vue&type=template&id=836e37a8&scoped=true"
import script from "./OverallSessionDurationChart.vue?vue&type=script&lang=js"
export * from "./OverallSessionDurationChart.vue?vue&type=script&lang=js"
import style0 from "./OverallSessionDurationChart.vue?vue&type=style&index=0&id=836e37a8&prod&lang=scss"
import style1 from "./OverallSessionDurationChart.vue?vue&type=style&index=1&id=836e37a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "836e37a8",
  null
  
)

export default component.exports